import classNames from 'classnames'

import * as styles from './AuthPanel.module.css'

function AuthPanel({
  children,
  className = styles.AuthPanel,
  withNotifications,
}) {
  return (
    <div
      className={classNames(className, {
        [styles.withNotifications]: withNotifications,
      })}
    >
      {children}
    </div>
  )
}

export default AuthPanel
